  <div class="col-12" [formGroup]="file.form">
    <div class="upload-wrap" [ngClass]="{'invalid':submitted &&!fileUploaded}" *ngIf="!fileUploaded">
      <input type="file" id="UploadItem" formControlName="file" (change)="uploadItem($event)" (drop)="onDrop($event)"
        (dragover)="onDragOver($event)" />
      <img src="./assets/images/icons/upload-doc.png" alt="">

      <p><a>Select the file</a> you want to upload<strong class="mandatory">*</strong><br>
        <span>{{fileMsg}}</span>
      </p>
    </div>
    <div class="validation-error" *ngIf="submitted && !fileUploaded">
      <span>{{requiredMsgError}}</span>
    </div>
    <div class="validation-error" *ngIf="errorMsg" #focusedElement>
      <p>Error Message</p>
      <span>{{errorMsg}}</span>
    </div>
    <div class="uploading" *ngIf="progress">
      <img src="assets/images/icons/doc.svg" alt="document icon" />
      <div class="uploader">
        <div class="upload-text">
          <p>{{files[0]?.[0]?.name}}</p>
          <p>{{progress}}%</p>
        </div>
        <div class="loader-track">
          <div class="loader-thumb" [style.width]="progress + '%'"></div>
        </div>
      </div>
      <img class="upload-close" src="assets/images/icons/close.svg" alt="close icon" />
    </div>
  </div>
  <div class="uploading uploaded" *ngIf="files?.length && showFiles && !errorMsg && !progress">
    <img src="assets/images/icons/doc.svg" alt="document icon" />
    <div class="uploader">
      <div class="upload-text">
        <p>{{files[0]?.[0]?.name}}</p>
      </div>
      <p class="text-sm">{{fileSize}} Document</p>
    </div>
    <div class="actions">
      <a class="delete" (click)="deleteFile()"></a>
    </div>
  </div>
